import Api from '../api';
import { errorHandler } from '../common';

const { axios: api } = Api;

const PREFIX = 'mcp/oauth';

export const completeMcpOauth = (request) =>
	errorHandler(async () => {
		const data = await api.post(`/${PREFIX}/complete`, { request });
		return { data: data.data };
	});
